// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_do-6";
export var emphasizeQuantity = "_do-3";
export var flatBottomCorners = "_do-5";
export var productImage = "_do-0";
export var quantityContainer = "_do-2";
export var tooltip = "_do-1";
export var wrapAndEllipsesOverflow = "_do-4";